import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AlertService } from "../../../services";
import { Subscription } from "rxjs/Subscription";
import { DashboardComponent } from "../dashboard-component";
import { HttpClient } from "@angular/common/http";
import { Provinces } from '../../provinces/provinces';
import { LocationGroup } from '../../location-group/location-group';

@Component({
    template: require('./bills-table.html'),
    selector: 'bills-table',
    styles: [require('./bills-table.css')]
})

export class BillsTableComponent implements DashboardComponent {

    private tableData: Array<any> = null;
    public subscription: Subscription = null;
    @Input() public header: string = '';
    @Input() public subHeader: string = '';
    @Input() public url: string;
    @Output() refreshed = new EventEmitter();

    constructor(
        private http: HttpClient,
        private autoMapperService: AutoMapperService,
        private alertService: AlertService
    ) {
    }

    public update(): void {
        let self: BillsTableComponent = this;
        this.subscription = this.http.get<any>(this.url)
            .subscribe(result => {
                self.tableData = result;
                self.refreshed.next();
            }, error => self.refreshed.next());
    }

    public updateDashboard(provinces:Array<Provinces>, locationGroup:Array<LocationGroup>): void {
        let self: BillsTableComponent = this;
        this.subscription = this.http.post<any>(this.url,{provinces,locationGroup})
        .subscribe(result => {
            self.tableData = result;
            self.refreshed.next();
        }, error => self.refreshed.next());
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/bills-table/bills-table.component.ts